"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var FamilyReference = /*#__PURE__*/function () {
  function FamilyReference(opt) {
    _classCallCheck(this, FamilyReference);

    this._id = null;
    this.density = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(FamilyReference, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = opt._id ? new ObjectId(opt._id) : null;
      this.density = opt.density || {};
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'family-reference.schema.json',
        type: 'object',
        properties: {
          _id: {
            type: 'object'
          },
          density: {
            type: 'object'
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return FamilyReference;
}();

module.exports = FamilyReference;